import { render, staticRenderFns } from "./PostBoardTopicNavigation.vue?vue&type=template&id=3d0c2aac&scoped=true&"
import script from "./PostBoardTopicNavigation.vue?vue&type=script&lang=js&"
export * from "./PostBoardTopicNavigation.vue?vue&type=script&lang=js&"
import style0 from "./PostBoardTopicNavigation.vue?vue&type=style&index=0&id=3d0c2aac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0c2aac",
  null
  
)

export default component.exports